module.exports = __webpack_public_path__ + "static/picture-wall-1ca1007f307859a796ed0166a28df5dd.png";